import { useQuery } from '@tanstack/react-query';

import { listClaimCampaigns } from '~/services/ClaimCampaignService';

import type { ListClaimCampaignsParams } from '~/types/claimCampaignTypes';

import { claimCampaignQueryKeys } from './claimCampaignQueryKeys';

interface UseListClaimCampaignsOptions {
  enabled?: boolean;
}

/**
 * Fetches a paginated list of claim campaigns with optional status filter.
 */
export function useListClaimCampaigns(params: ListClaimCampaignsParams, options: UseListClaimCampaignsOptions = {}) {
  const { enabled = true } = options;

  return useQuery({
    queryKey: claimCampaignQueryKeys.list(params),
    queryFn: async ({ signal }) => {
      return await listClaimCampaigns(params, { signal });
    },
    placeholderData: (previousData) => previousData,
    enabled,
    retry: false,
  });
}
